var _defs, _g, _path, _g2, _g3, _path2, _path3, _g4, _g5, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__Path_992",
    width: 50.869,
    height: 37.871,
    x: 14.259,
    y: 2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__Path_994",
    width: 35.777,
    height: 47.318,
    x: 43.859,
    y: 36.153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__Path_995",
    width: 35.59,
    height: 47.46,
    x: -0.344,
    y: 35.975,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__Path_998",
    width: 32.997,
    height: 38.419,
    x: 39.503,
    y: 15.388,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__Path_999",
    width: 33.209,
    height: 38.312,
    x: 6.819,
    y: 15.197,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_56",
    d: "M0 0H80V80H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 56",
    transform: "translate(-1666 -880)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1,.prefix__cls-4{fill:#30346B}.prefix__cls-3{fill:#30346B}.prefix__cls-4{opacity:.5}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(1666 880)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_125",
    "data-name": "Group 125",
    transform: "translate(-457 -1463)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1209 583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_992-2",
    d: "M1390.925 2709.469l16.567-9.807 16.3 9.807-16.731 10.064z",
    className: "prefix__cls-1",
    "data-name": "Path 992",
    transform: "translate(-1367.67 -2691.66)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_993",
    d: "M1418.578 2720.632l6.1 3.841 6.638-3.841-6.211-3.771z",
    className: "prefix__cls-3",
    "data-name": "Path 993",
    transform: "translate(-2594.408 -2119.697)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1209 583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_994-2",
    d: "M1473.51 2804.331v19.937l17.777-9.908v-19.41z",
    className: "prefix__cls-1",
    "data-name": "Path 994",
    transform: "translate(-1420.65 -2752.8)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1209 583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_995-2",
    d: "M1350.184 2794.452v19.674l17.59 9.786v-19.946z",
    className: "prefix__cls-1",
    "data-name": "Path 995",
    transform: "translate(-1341.53 -2752.48)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_996",
    d: "M1488.6 2822.743l6.883-3.831v8.158l-6.883 3.964z",
    className: "prefix__cls-3",
    "data-name": "Path 996",
    transform: "translate(-2639.332 -2185.17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_997",
    d: "M1364.72 2817.74v8.492l7.117 4.158v-8.481z",
    className: "prefix__cls-3",
    "data-name": "Path 997",
    transform: "translate(-2559.854 -2184.418)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1209 583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_998-2",
    d: "M1461.357 2748.182l8.913 5.29v12.333l6.084-3.593v-11.448l-9.564-5.379z",
    className: "prefix__cls-4",
    "data-name": "Path 998",
    transform: "translate(-1412.85 -2721)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1209 583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_999-2",
    d: "M1370.168 2750.253v11.736l5.806 3.174v-11.742l9.4-5.674-5.75-2.9z",
    className: "prefix__cls-4",
    "data-name": "Path 999",
    transform: "translate(-1354.35 -2720.65)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_120",
    "data-name": "Group 120",
    transform: "translate(2.264 -.576)",
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1001",
    d: "M-1171.674 647.328v6.684l-9.439-6.157v-6.172z",
    className: "prefix__cls-1",
    "data-name": "Path 1001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1002",
    d: "M-1181.362 647.336V654l9.689-6.144v-6.172z",
    className: "prefix__cls-1",
    "data-name": "Path 1002",
    transform: "translate(9.693)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyMe);
export default __webpack_public_path__ + "static/media/verify-me.851fc6f6f6d50d828294bf507a38a4e6.svg";
export { ForwardRef as ReactComponent };